import { render, staticRenderFns } from "./card-manage.vue?vue&type=template&id=8daa9528&scoped=true&"
import script from "./card-manage.vue?vue&type=script&lang=js&"
export * from "./card-manage.vue?vue&type=script&lang=js&"
import style0 from "./card-manage.vue?vue&type=style&index=0&lang=less&"
import style1 from "./card-manage.vue?vue&type=style&index=1&id=8daa9528&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8daa9528",
  null
  
)

export default component.exports